import { Radio } from "lucide-react";
import { InstitutionMark, VerifiedBadge } from "@/components/Brand";

export function InstitutionList({ items, onPick }) {
  if (!items.length) return <p className="py-16 text-center text-muted-foreground">Nenhuma instituição verificada ainda.</p>;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="institution-list">
      {items.map((i, idx) => (
        <button key={i.id} onClick={() => onPick(i)} data-testid={`institution-item-${i.id}`} style={{ animationDelay: `${idx * 60}ms` }}
          className="rise flex items-center gap-4 rounded-2xl border border-white/5 bg-card p-4 text-left transition-colors hover:border-[hsl(var(--gold))]/40">
          <InstitutionMark name={i.name} logo={i.logo_url} color={i.brand_color} size={52} />
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-1.5">
              <span className="truncate font-bold">{i.name}</span>
              <VerifiedBadge size={16} />
            </div>
            <p className="text-xs text-muted-foreground">{i.denomination === "catolica" ? "Católica" : "Evangélica"} · {i.leader_name}</p>
          </div>
          <span className="inline-flex items-center gap-1 rounded-full bg-red-500/15 px-2.5 py-1 text-xs font-bold text-red-400">
            <Radio size={12} /> {i.live_rooms}
          </span>
        </button>
      ))}
    </div>
  );
}
